<template>
    <b-container>
        <b-card class="bg-template shadow mt-4">
            <b-row>
                <b-col cols="auto" class="pr-1">
                    <figure class="avatar avatar-60">
                        <img :src="user.photo ? '/'+user.photo : '/img/user-default.png'"
                             :alt="(user.name + ' ' + user.lname).replace(',', '')"
                             :title="(user.name + ' ' + user.lname).replace(',', '')">
                    </figure>
                </b-col>
                <b-col class="pl-2">
                    <h5 class="mb-1">{{ (user.name + ' ' + user.lname).replace(',', '') }}</h5>
                    <p class="text-mute small mb-0">Última Conexión:
                        {{ new Date((''+user.last_access).replace(/ /g,"T")) | moment("DD/MM/YYYY HH:mm") }}</p>
                    <p class="text-mute small">IP: {{ user.ip }}</p>
                </b-col>
            </b-row>
        </b-card>
        <h6 class="subtitle px-2">Pagos Recientes <a class="float-right small" @click="getLink('History')"><b>Ver Todos</b></a></h6>
        <template v-if="!loading">
            <div class="card shadow border-0 mb-3" v-for="item in payments" v-bind:key="item.id" v-if="payments">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <p class="text-mute small text-secondary mb-2"><b>ID:</b> {{ item.id }}<span class="float-right">{{ new Date((''+item.date).replace(/ /g,"T")) | moment("DD/MM/YYYY hh:mm A") }}</span></p>
                            <p class="text-mute small text-secondary mb-2">{{ Number(item.amount_send).toLocaleString("en-US") + ' ' + item.currency_send }} ➤ {{ Number(item.amount_receiver).toLocaleString("en-US") + ' ' + item.currency_receiver }}</p>
                            <div class="progress h-4">
                                <div :class="'progress-bar bg-'+item.color" role="progressbar" :style="'width:'+item.value+'%'" :aria-valuenow="item.value" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-auto pl-0">
                            <b-avatar button size="50" :variant="item.color" class="no-shadow border-0 bg-template" @click="getLink('Details', item.id)" icon="eye-fill"></b-avatar>
                        </div>
                    </div>
                </div>
            </div>
            <h6 class="text-secondary text-center pt-3" v-else>No hay pagos recientes</h6>
        </template>
        <template v-else>
            <b-card class="card shadow border-0 mb-3" v-for="(k, i) in list" v-bind:key="k.id">
                <b-skeleton :id="k+i" animation="fade" width="85%"></b-skeleton>
                <b-skeleton :id="k+i" animation="fade" width="55%"></b-skeleton>
                <b-skeleton :id="k+i" animation="fade" width="70%"></b-skeleton>
            </b-card>
        </template>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Home",
    props: [ 'user' ],
    data: () => ({
        loading: true,
        payments: [],
        list: [
            { id: 1 },
            { id: 2 },
            { id: 3 },
            { id: 4 },
            { id: 5 }
        ]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'homepage');
        this.getIni();
    },
    methods: {
        getIni() {
            axios.get('/api/customer/home').then((res) => {
                if (res.data.status === 'success') {
                    this.payments = res.data.payments;
                    this.$emit('success');
                } else {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
            });
        },
        getLink(route, id) {
            this.$router.push({ name: route, params: { id: id } });
        }
    }
}
</script>

<style scoped>

</style>
